export const state = {
  locations: [],
  schools: [],
  locationsById: [],
  zones: [],
};
